var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"c-badge-wrapper badge",class:_setup.typeClasses},[(!_setup.slots.default)?[_vm._v(_vm._s(_vm.text))]:_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }